import { setRemoteDefinitions } from '@nx/angular/mf';

/**
 * Shell entry point — NO @complexcare/* imports allowed here.
 *
 * Importing from @complexcare/conductor barrel pulls in Angular-dependent FHIR
 * services which causes "loadShareSync" errors because Angular shared packages
 * are loaded synchronously before the async boundary (import('./bootstrap')).
 *
 * MfDebugService is initialized inside bootstrap.ts instead.
 */

// Lightweight pre-bootstrap console logging (debug mode only)
const mfDebugEnabled = localStorage.getItem('symphony.mf.debug') === 'true';
const mfLog = (msg: string, ...args: any[]) => {
  if (mfDebugEnabled) console.log(`[MF Shell] ${msg}`, ...args);
};

mfLog('Fetching module-federation.manifest.json...');

fetch('/module-federation.manifest.json', { cache: 'no-store' })
  .then((res) => {
    if (!res.ok) {
      throw new Error(`Manifest fetch failed: ${res.status} ${res.statusText}`);
    }
    return res.json();
  })
  .then((remotes: Record<string, string>) => {
    mfLog('Manifest loaded:', remotes);

    // Set remote definitions
    setRemoteDefinitions(remotes);

    // Store remotes for MfDebugService to pick up inside bootstrap
    (window as any).__mfRemotes = remotes;

    return remotes;
  })
  .then(() => {
    mfLog('Starting bootstrap...');

    import('./bootstrap').catch((err) => {
      console.error('[MF Shell] Bootstrap failed:', err);
    });
  })
  .catch((err) => {
    console.error('[MF Shell] Manifest fetch failed:', err);
  });
